export default __webpack_public_path__ + "static/char-s-05-jp-bcf961368e3b97a463dbb70c137633f0.webp";